import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import selectors from './selectors';

const options = {
  name: 'activityTypes',
  baseType: 'ACTIVITY_TYPES',
  apiEndpoint: 'activity_types'
};

const operations = createMetadataAPIOperations(options);

export { operations, selectors };
export default createMetadataAPIReducer(options);
